import React, {Component} from 'react';
import {
    Button,
    Container,
    Header, Grid, Table, Checkbox
} from 'semantic-ui-react';
import update from 'react-addons-update';
import {connect} from "react-redux";
import moment from "moment";
import TimePicker from "rc-time-picker/es/TimePicker";

import {showToast} from "../../actions/ToastAction";
import BusinessHourData from "../../data/BusinessHoursData";
import CheckPermission from "../extras/CheckPermission";

const business_hours = [
    {name: 'Domingo', key: 'sunday'},
    {name: 'Lunes', key: 'monday'},
    {name: 'Martes', key: 'tuesday'},
    {name: 'Miércoles', key: 'wednesday'},
    {name: 'Jueves', key: 'thursday'},
    {name: 'Viernes', key: 'friday'},
    {name: 'Sábado', key: 'saturday'},
];

class StateChange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            label: '',
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.store) {
            this.setState({value: nextProps.value});
        }
    }

    onChange = () => {
        let value = this.state.value === undefined ? true : !this.state.value;
        this.setState({value: !this.state.value});
        this.props.callback(this.props.day, this.props.type, value)
    };

    render() {
        return <Checkbox
            label={this.state.value ? 'Abierto' : 'Cerrado'}
            checked={this.state.value}
            onChange={this.onChange}
            toggle
        />
    }
}

class TimeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            date_selected: props.value,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.store) {
            let value = moment(nextProps.value, 'h:mm a');
            this.setState({value, date_selected: value});
        }
    }

    onChangeDate = (date_selected) => {
        this.setState({date_selected});
    };

    onAccept = (panel) => {
        this.setState({value: this.state.date_selected});
        this.props.callback(this.props.day, this.props.type, this.state.date_selected.format('h:mm a'));
        panel.close()
    };

    onClose = () => {
        this.setState({date_selected: this.state.value});
    };

    onCancel = (panel) => {
        this.setState({date_selected: this.state.value});
        panel.close()
    };

    render() {
        return <TimePicker
            format='h:mm a'
            value={this.state.date_selected}
            use12Hours={true}
            allowEmpty={false}
            minuteStep={10}
            name='sunday'
            showSecond={false}
            showToday={false}
            disabled={false}
            animation="slide-up"
            inputReadOnly={true}
            onClose={this.onClose}
            onChange={this.onChangeDate}
            addon={(panel) =>
                <div>
                    <Button.Group basic>
                        <Button onClick={() => this.onAccept(panel)}>Aceptar</Button>
                        <Button onClick={() => this.onCancel(panel)}>Cancelar</Button>
                    </Button.Group>
                </div>
            }
        />
    }
}

class BusinessHoursForm extends Component {

    constructor() {
        super();

        this.state = {
            data: {
                sunday: {},
                monday: {},
                tuesday: {},
                wednesday: {},
                thursday: {},
                friday: {},
                saturday: {},
                store: null
            },
            sending: true,
        };
    }

    componentDidMount() {
        this.initialFetch();
    }

    onSubmit = () => {
        this.setState({sending:true});
        BusinessHourData.update(this.state.data, res => {
            if(res && res.update){
                this.props.showToast({message:'Actualización exitosa!', type:'success'});
            }else{
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
            this.setState({sending:false});
        });
    };

    onChangeDate = (day, type, value) => {
        let data = update(this.state, {
            data: {
                [day]: {
                    [type]: {
                        $set: value
                    }
                }
            }
        });
        this.setState(data);
    };

    async initialFetch() {
        BusinessHourData.get(data => {
            if (!data.hasOwnProperty('detail')) {
                this.setState({data, sending: false});
            }
        });
    }

    render() {
        return (
            <Container>
                <Header as='h2'>
                    <Header.Content>
                        Horario de Atención
                    </Header.Content>
                </Header>
                <Grid>
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={10} computer={10}>
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Día</Table.HeaderCell>
                                        <Table.HeaderCell>Hora de Apertura</Table.HeaderCell>
                                        <Table.HeaderCell>Hora de Cierre</Table.HeaderCell>
                                        <Table.HeaderCell>Estado</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {business_hours.map((day, index) => {
                                        return <Table.Row key={index}>
                                            <Table.Cell><strong>{day.name}</strong></Table.Cell>
                                            <Table.Cell>
                                                <TimeSelect
                                                    callback={this.onChangeDate}
                                                    day={day.key}
                                                    type='openning_time'
                                                    store={1}
                                                    value={this.state.data[day.key] ? this.state.data[day.key].openning_time : null}
                                                />
                                            </Table.Cell>
                                            <Table.Cell>
                                                <TimeSelect
                                                    callback={this.onChangeDate}
                                                    day={day.key}
                                                    type='closing_time'
                                                    store={1}
                                                    value={this.state.data[day.key] ? this.state.data[day.key].closing_time : null}
                                                />
                                            </Table.Cell>
                                            <Table.Cell>
                                                <StateChange
                                                    callback={this.onChangeDate}
                                                    day={day.key}
                                                    type='opened'
                                                    store={1}
                                                    value={this.state.data[day.key] ? this.state.data[day.key].opened : null}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    })
                                    }
                                </Table.Body>
                                <Table.Footer fullWidth>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan='4'>
                                            <Button primary fluid onClick={this.onSubmit} loading={this.state.sending} disabled={this.state.sending}>
                                                Actualizar Información
                                            </Button>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <CheckPermission access='settings__my_bussiness'/>
            </Container>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(toast) {
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(BusinessHoursForm)


// WEBPACK FOOTER //
// ./src/components/settings/BusinessHoursForm.js